import { toBaseSnapshot, toCloudProfile } from './state.js';

const API = 'https://clash-api.terra-anvil.com';

export class OnlineService {
  constructor(state, onChange = () => {}) {
    this.state = state;
    this.onChange = onChange;
    this.online = false;
  }

  headers(json = true) {
    const headers = {};
    if (json) headers['content-type'] = 'application/json';
    if (this.state.online.playerId) headers['x-player-id'] = this.state.online.playerId;
    if (this.state.online.authToken) headers.authorization = `Bearer ${this.state.online.authToken}`;
    return headers;
  }

  async request(path, options = {}) {
    const response = await fetch(`${API}${path}`, {
      ...options,
      headers: { ...this.headers(options.body !== undefined), ...(options.headers || {}) }
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || `online-${response.status}`);
    return data;
  }

  async connect() {
    try {
      const payload = {
        playerName: this.state.playerName,
        playerId: this.state.online.playerId,
        authToken: this.state.online.authToken
      };
      const result = await this.request('/v2/register', { method: 'POST', body: JSON.stringify(payload) });
      this.state.online.playerId = result.playerId;
      this.state.online.authToken = result.authToken || this.state.online.authToken;
      this.state.online.friendCode = result.friendCode;
      this.online = true;
      await this.sync();
      this.onChange();
      return result;
    } catch (error) {
      this.online = false;
      this.onChange();
      throw error;
    }
  }

  async sync() {
    if (!this.state.online.playerId) return null;
    const result = await this.request(`/v2/players/${encodeURIComponent(this.state.online.playerId)}/profile`, {
      method: 'PUT', body: JSON.stringify(toCloudProfile(this.state))
    });
    this.state.online.syncedAt = Date.now();
    this.online = true;
    this.onChange();
    return result;
  }

  async uploadBase() {
    return this.request(`/v2/players/${encodeURIComponent(this.state.online.playerId)}/base`, {
      method: 'PUT', body: JSON.stringify(toBaseSnapshot(this.state))
    });
  }

  async addFriend(friendCode) {
    return this.request(`/v2/players/${encodeURIComponent(this.state.online.playerId)}/friends`, {
      method: 'POST', body: JSON.stringify({ friendCode: String(friendCode).trim().toUpperCase() })
    });
  }

  async friends() {
    return this.request(`/v2/players/${encodeURIComponent(this.state.online.playerId)}/friends`, { method: 'GET' });
  }

  async friendBase(friendCode) {
    return this.request(`/v2/friends/${encodeURIComponent(friendCode)}/base`, { method: 'GET' });
  }

  async recordBattle(opponentName, destructionPercent, spiritMarks) {
    if (!this.state.online.playerId) return null;
    return this.request(`/v2/players/${encodeURIComponent(this.state.online.playerId)}/battles`, {
      method: 'POST', body: JSON.stringify({ opponentName, destructionPercent, spiritMarks })
    });
  }
}
